import {BannerItemDto} from '../../common/shared/api/gateway/BannerItemDto.interface';
import {
  BannerViewType,
  GroupType,
  ItemType,
  SectionType,
  TopSection,
} from '../generated/types';
import {createBannerItem} from './BannerItem';

export function createTopSection({
  layoutId,
  bannerList,
}: {
  layoutId: string;
  bannerList: BannerItemDto[];
}): TopSection {
  const sectionId = `${layoutId}-section-top`;
  return {
    id: sectionId,
    type: SectionType.Top,
    groups: [
      {
        id: `${sectionId}-group-top`,
        type: GroupType.BigBanner,
        items: bannerList.map(banner =>
          createBannerItem({
            item: banner,
            itemType: ItemType.Banner,
            viewType: BannerViewType.Square,
          })
        ),
      },
    ],
  };
}
